import React from 'react'
import { SideNavigation, SideNavigationV2 } from '@intellihr/blueberry'
import { useNavigationItems } from 'src/services/layout/components/PageFrame/components/Navigation/useNavigationItems'

const DesktopNavigation: React.FC = () => {
  const navigationData = useNavigationItems()

  if (!navigationData) {
    return (
      <SideNavigation
        items={[]}
        showSkeleton
      />
    )
  }

  return (
    <SideNavigationV2
      nativeApps={navigationData.nativeApps}
      externalApps={navigationData.externalApps}
      testId="desktop-navigation"
      logo={navigationData.logoOnBlackUrl}
      items={navigationData.primaryItems}
      secondaryItems={navigationData.secondaryItems}
    />
  )
}

export { DesktopNavigation }
